import store from "../stores/store"
import Vue from "vue"

export default {
    /**
     * Applique le middleware
     */
    handle: (to, from, next) => {
        if (!store.getters.hasModification) {
            return next()
        }

        Vue.prototype.$confirm('Voulez-vous quitter cette page sans avoir enregistré vos modifications ?').then(() =>{
            store.dispatch("resetModification")
            next()
        })
    }
}
